var contactsService=function() {
};

contactsService.prototype.getName = function(contact) {
  return contact?(contact.firstname===''?'':contact.firstname+' ')+contact.name:'';
};

angular.module('app').service('contactsService',[contactsService]);
